/**
 * Firebase JS SDK initialisation for the web client.
 *
 * Values come from REACT_APP_FIREBASE_* in .env. They are intentionally
 * baked into the production bundle (Firebase docs explicitly call this
 * safe — security comes from Authorized Domains + Security Rules, not
 * the API key). We still pull them from env so you can rotate them
 * without a code change.
 */
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  // We rely on browserLocalPersistence by default — Firebase persists the
  // session in IndexedDB, NOT in localStorage. That means a stolen XSS payload
  // can't simply read the token; it would have to call into Firebase's SDK,
  // which is harder to weaponise generically. This is a meaningful upgrade
  // over the old `localStorage.getItem('ce_token')` approach.
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Fail loud at boot if the env file wasn't loaded — far better than a
// confusing "auth/invalid-api-key" error on first sign-in attempt.
if (!firebaseConfig.apiKey) {
  // eslint-disable-next-line no-console
  console.error(
    '[firebase] REACT_APP_FIREBASE_* env vars missing. Copy frontend/.env.example to .env and fill in the values from Firebase Console → Project settings → Your apps.'
  );
}

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

export const googleProvider = new GoogleAuthProvider();
// Always show the account chooser — avoids surprising the user when they're
// signed in to a different Google account in their browser.
googleProvider.setCustomParameters({ prompt: 'select_account' });
